import React, { Component } from "react";
import "./SearchPanel.scss";

export default class SearchPanel extends Component {
    state = {
        searchText: "",
        showSearchText: undefined
    };

    onValueChange = e => {
        if (e.key === "Enter") {
            this.search();
        } else {
            this.setState({
                searchText: e.target.value
            });
        }
    };

    search = () => {
        if (this.state.searchText === "" && !this.state.showSearchText) return;
        this.props.onSearch(this.state.searchText);
        let showSearchText =
            this.state.searchText !== "" ? this.state.searchText : undefined;
        this.setState({
            showSearchText: showSearchText
        });
    };

    render() {
        return (
            <div className="col-lg-3 col-md-6 col-12 mt-lg-3 mt-md-3 mt-sm-1 pl-3">
                <div className="row mb-3">
                    <input
                        className="search-input"
                        type="text"
                        onChange={ this.onValueChange }
                        onKeyPress={ this.onValueChange }
                    />
                    <button className="btn search-btn" onClick={ this.search }>
                        <span className="fa fa-search"></span>
                    </button>
                </div>
                <div className="row">
                    {this.state.showSearchText ? (
                        <p className="badge">
                            Showing results for: "{ this.state.showSearchText }"
                        </p>
                    ) : (
                        ""
                    )}
                </div>
            </div>
        );
    }
}
